// 常量路由
export const constantRoutes = [
  {
    path: '/',
    redirect: '/home',
    meta: {
      hidden: true
    }
  },
  {
    path: '/login',
    meta: {
      hidden: true
    },
    component: () => import('@/views/login/index')
  },
  {
    path: '/home',
    name: 'Home',
    meta: {
      icon: 'el-icon-s-home',
      name: '首页',
      affix: true
    },
    component: () => import('../views/home/index.vue')
  }
]

// 任意路由
export const anyRoutes = [
  //
]

// 动态路由
export const asyncRoutes = () => [
  {
    path: '/user-manage',
    name: 'UserManage',
    component: () => import('@/views/user-manage/index.vue'),
    meta: { name: '用户管理', icon: 'el-icon-user-solid' },
    children: [
      {
        path: '/user-manage/member/list',
        name: 'MemberList',
        component: () => import('@/views/user-manage/member/list.vue'),
        meta: { name: '用户列表', keepAlive: true }
      },
      {
        path: '/user-manage/member/detail/:id?',
        name: 'MemberDetail',
        component: () => import('@/views/user-manage/member/detail.vue'),
        meta: {
          name: '用户详情',
          hidden: true,
          keepAlive: true,
          activeMenu: '/user-manage/member/list'
        }
      },
      {
        path: '/user-manage/black/list',
        name: 'BlackList',
        component: () => import('@/views/user-manage/blacklist/list.vue'),
        meta: { name: '黑名单列表', keepAlive: true }
      },
      {
        path: '/user-manage/black/add',
        name: 'BlackAdd',
        component: () => import('@/views/user-manage/blacklist/addOrEdit.vue'),
        meta: { name: '新增黑名单', hidden: true, activeMenu: '/user-manage/black/list' }
      },
      {
        path: '/user-manage/black/edit/:id?',
        name: 'BlackEdit',
        component: () => import('@/views/user-manage/blacklist/addOrEdit.vue'),
        meta: { name: '编辑黑名单', hidden: true, activeMenu: '/user-manage/black/list' }
      },
    ]
  },
  {
    path: '/power-manage',
    name: 'PowerManage',
    redirect: '/power-manage/user/list',
    component: () => import('@/views/power-manage/index.vue'),
    meta: { name: '权限管理', icon: 'el-icon-s-check' },
    children: [
      {
        path: '/power-manage/user/list',
        name: 'UserList',
        component: () => import('@/views/power-manage/user/list.vue'),
        meta: { name: '管理员' }
      },
      {
        path: '/power-manage/user/add',
        name: 'UserAdd',
        component: () => import('@/views/power-manage/user/addEdit.vue'),
        meta: { name: '新增管理员', hidden: true, activeMenu: '/power-manage/user/list' }
      },
      {
        path: '/power-manage/user/edit/:id?',
        name: 'UserEdit',
        component: () => import('@/views/power-manage/user/addEdit.vue'),
        meta: { name: '编辑管理员', hidden: true, activeMenu: '/power-manage/user/list' }
      },
      {
        path: '/power-manage/role/list',
        name: 'RoleList',
        component: () => import('@/views/power-manage/role/list.vue'),
        meta: { name: '角色管理' }
      },
      {
        path: '/power-manage/role/addEdit',
        name: 'RoleAdd',
        component: () => import('@/views/power-manage/role/addEdit.vue'),
        meta: { name: '新增', hidden: true, activeMenu: '/power-manage/role/list' }
      },
      {
        path: '/power-manage/role/addEdit/:id?',
        name: 'RoleEdit',
        component: () => import('@/views/power-manage/role/addEdit.vue'),
        meta: { name: '编辑', hidden: true, activeMenu: '/power-manage/role/list' }
      },
      {
        path: '/power-manage/menu/list',
        name: 'MenuList',
        component: () => import('@/views/power-manage/menu/list.vue'),
        meta: { name: '菜单管理', keepAlive: true }
      },
      {
        path: '/power-manage/menu/addEdit/:menuId?/:parentId?',
        name: 'MenuAdd',
        component: () => import('@/views/power-manage/menu/addEdit.vue'),
        meta: { name: '新增', hidden: true, activeMenu: '/power-manage/menu/list' }
      },
      {
        path: '/power-manage/menu/addEdit/:menuId?/:parentId?',
        name: 'MenuEdit',
        component: () => import('@/views/power-manage/menu/addEdit.vue'),
        meta: { name: '编辑', hidden: true, activeMenu: '/power-manage/menu/list' }
      }
    ]
  }
]
